import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in es.servicios.regulatory-affairs.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/es/servicios/regulatory-affairs")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
